import { CommonModule } from '@angular/common';
import { Component, inject, input, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumToStringPipe } from '@app/features-modules/gestao-bolseiros/pipes/enum-to-string.pipe';
import { TesteService } from '@app/shared/services/teste.service';
import { ApiService } from '@core/providers/http';
import { TagModule } from 'primeng/tag';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-card-empresa-03',
  imports: [CommonModule, EnumToStringPipe, TagModule, AvatarModule],
  providers: [ApiService],
  templateUrl: './card-empresa-03.component.html',
  styleUrls: ['./card-empresa-03.component.scss'],
  standalone: true
})
export class CardEmpresa03Component{
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  constructor(private router: Router, private TesteService: TesteService) {}
  @Input() empresa: any;
  @Input() nome!: string;
  @Input() email!: string;
  @Input() telefone!: string;
  @Input() endereco!: string;
  @Input() foto: string | ArrayBuffer | null = null;
  @Input() site!: string;
  @Input() provincia!: string;
  @Input() natureza!: string;
  @Input() activo!: boolean;
  @Input() idade!: any;
  @Input() pais!: any;
  @Input() subSector!: any;
  @Input() estado!: any;
  @Input() url!: any;
  @Input() localizacao!: any;

  route = inject(ActivatedRoute);

  sponsor: string = 'Catoca';
  vacancies: number = 30;
  description: string =
    'Uma oportunidade para estudantes de alto desempenho ingressarem na graduação com cobertura integral das mensalidades. Destinada a alunos que concluíram o ensino médio com média igual ou superior a 17 valores.';
  startDate: string = '13/01/2025';
  endDate: string = '25/05/2025';
  tags: string[] = ['Bolsa de Mérito', 'Mestrado', 'Integral', 'Interna'];

  extraParticipants: number = 5;


  Show = false;

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  AddRepresent(event: Event) {
    event.stopPropagation();
    this.router.navigate([
      '/gestao-bolseiros/empresa-gestora/add-representante',
      // this.instituicaoEnsino.id,
      this.empresa.id
    ]);
    // this.TesteService.toggleShowEmpresas();
  }


}
